// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('product.businessareas.new', {
        url:'/new',
        views: {
            'productView@product': {
            templateUrl: 'main/product/businessareas/businessarea/businessarea.tpl.html',
            controller: 'BusinessAreaController as vm'
        }},
        resolve: {
            businessarea: function() { return {}; },
            isNewBusinessArea: function() {return true;}
        }
    });

    $stateProvider.state('product.businessareas.businessarea', {
        url:'/{businessareaId}',
        views: {
            'productView@product': {
            templateUrl: 'main/product/businessareas/businessarea/businessarea.tpl.html',
            controller: 'BusinessAreaController as vm'
        }},
        resolve: {
            businessarea: businessareaResolver,
            isNewBusinessArea: function() {return false;}
        }
    });

}

// @ngInject
function businessareaResolver($stateParams, BusinessAreasApiService) {
    return BusinessAreasApiService.getBusinessArea($stateParams.businessareaId);
}

// @ngInject
function BusinessAreaController($state, businessarea, loadSpinnerService, BusinessAreasApiService, ToasterService, confirmationDialogService, $translate, isNewBusinessArea) {
    var vm = this;

    var businessareaCopy = {};

    vm.businessarea = businessarea;
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactBusinessAreaView') === 'true';
    vm.reactBusinessAreaId = isNewBusinessArea ? null : (businessarea && businessarea.id != null ? businessarea.id : null);

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveBusinessArea = saveBusinessArea;
    vm.deleteBusinessArea = deleteBusinessArea;

    vm.isNewBusinessArea = isNewBusinessArea;
    vm.isEditing = vm.isNewBusinessArea;

    vm.isBusinessAreaCodeValid = isBusinessAreaCodeValid;
    vm.isAllInformationValid = isAllInformationValid;

    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewBusinessArea) {
            vm.businessarea = {};
        }

    }

    function enableEditing() {
        businessareaCopy = angular.copy(vm.businessarea);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.businessarea = businessareaCopy;
        vm.isEditing = false;
    }

    function saveBusinessArea() {
        if (vm.isNewBusinessArea) {
            saveNewBusinessArea();
        } else {
            updateBusinessArea();
        }
    }

    function saveNewBusinessArea() {
        loadSpinnerService.start('mainSpinner');
        BusinessAreasApiService.createBusinessArea(vm.businessarea).then(function(response) {
            vm.businessarea = response;
            prepareData();
            vm.isNewBusinessArea = false;
            vm.isEditing = false;
            $state.go('product.businessareas.businessarea', {businessareaId: vm.businessarea.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateBusinessArea() {
        loadSpinnerService.start('mainSpinner');

        BusinessAreasApiService.updateBusinessArea(vm.businessarea).then(function(response) {
            vm.businessarea = response;
            prepareData();
            vm.isNewBusinessArea = false;
            vm.isEditing = false;
            $state.go('product.businessareas.businessarea', {businessareaId: vm.businessarea.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteBusinessArea() {
        confirmationDialogService
            .showDialog($translate.instant('businessarea.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    BusinessAreasApiService.deleteBusinessArea(vm.businessarea.id).then(function(response) {
                        vm.businessarea = response;
                        prepareData();
                        vm.isNewBusinessArea = false;
                        vm.isEditing = false;
                        $state.go('product.businessareas');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(businessarea) {
        businessarea.showEditForm = !businessarea.showEditForm;
    }

    function prepareData() {
        if (vm.businessarea === undefined) {
            return;
        }

        vm.businessareaCopy = angular.copy(vm.businessarea);
    }

    function isAllInformationValid() {
        return isBusinessAreaCodeValid();
    }

    function isBusinessAreaCodeValid() {
        if (!vm.businessarea.code) { return false; }
        if (vm.businessarea.code.length > 20) { return false; }

        return true;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('businessareas.businessarea', [])
    .config(stateConfig)
    .controller('BusinessAreaController', BusinessAreaController);
